export default "__VITE_ASSET__5076f57f__"